import { Create } from 'react-admin'

import PlaylistForm from './PlaylistForm'

const PlaylistCreate = props => (
  <Create redirect="list" {...props}>
    <PlaylistForm isCreating />
  </Create>
)

export default PlaylistCreate
